import { render } from "./StoreUsersView.vue?vue&type=template&id=28fee200"
import script from "./StoreUsersView.vue?vue&type=script&lang=js"
export * from "./StoreUsersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__